export default function React_ES6_Arrow_Functions() {
  return (
    <div>
      <h1>React_ES6_Arrow_Functions Component</h1>
      <p>This is the React_ES6_Arrow_Functions tutorial page.</p>
    </div>
  );
}
